import React from "react";
import { http } from "../../lib/http";
import { useWebSocket } from "../../context/WebSocketContext";

export default function ConnectionBanner({ onSimulateOrder }) {
  const { wsConnected } = useWebSocket();
  const handleSimulateOrder = async () => {
    try {
      await http.post('/fe/simulate-order');
      console.log('Order simulated successfully');
      if (onSimulateOrder) onSimulateOrder();
    } catch (error) {
      console.error('Error simulating order:', error);
    }
  };

  return (
    <div className="connection-banner">
      <div className="connection-status">
        <span className={`status-indicator ${wsConnected ? "connected" : "disconnected"}`}></span>
        <span className="status-text">
          {wsConnected ? "WebSocket Connected" : "WebSocket Disconnected"}
        </span>
      </div>
      <div className="connection-actions">
        <button className="btn-simulate" onClick={handleSimulateOrder} disabled={wsConnected}>
          Resume
        </button>
      </div>
    </div>
  );
}
